import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {budgetSeasonString, ensureNotObject} from "../common";
import * as common from "../styles/common.module.scss";

export function RenderSetOriginalRevenueMarketRentMode(props: RendererProps): ReactElement {
    const budgetYear = props.variables["budgetYear"];
    const mode = props.variables["originalRevenueMarketRentModeType"];

    return <div>
        <div className={common.textHeader}>{budgetSeasonString(budgetYear)}</div>
        <div>Mode: {ensureNotObject(mode)}</div>
    </div>;
}